import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

var getColorClassnames = function getColorClassnames(color) {
  if (!color) {
    return null;
  }

  var colorAliases = {
    disabled: 'gray200',
    dark: 'gray800',
    default: 'gray600',
    invalid: 'red400',
    selected: 'blue400'
  };
  var colorAlias;
  Object.keys(colorAliases).forEach(function (alias) {
    if (alias === color) {
      colorAlias = alias;
    }
  });
  var iconColor = colorAlias ? colorAliases[colorAlias] : color;
  return "Icon-color Icon-color--".concat(iconColor);
};

export default getColorClassnames;